<template>
  <v-card-actions class="px-6 pt-0 pb-5 d-flex justify-space-between">
    <div>
      <slot name="leftActions" />
    </div>

    <div class="d-flex d-inline-flex">
      <slot name="rightActions">
        <v-btn
          color="primary"
          outlined
          class="px-2 d-flex align-center"
          @click="close"
        >
          <v-icon v-if="!isXs" class="uikit-icon close primary" />
          <span class="btn-text">{{ isShowMode ? 'Закрыть' : 'Отмена' }}</span>
        </v-btn>

        <v-btn
          v-if="!isShowMode"
          :loading="saveBtnLoading"
          :disabled="isShowMode || isInvalid"
          color="primary"
          class="ml-2 px-2 d-flex align-center"
          @click="save"
        >
          <v-icon
            v-if="!isXs"
            class="uikit-icon"
            :class="[
              (isShowMode || isInvalid) ? 'greylighten1' : 'white',
              isEdit ? 'check' : 'plus',
            ]"
          />
          <span class="btn-text">
            {{ titleForConfirm ? 'Скачать' : (isEdit ? 'Сохранить' : 'Добавить') }}
          </span>
        </v-btn>
      </slot>
    </div>
  </v-card-actions>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DialogCardActions',

  props: {
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    isEdit: Boolean,
    isInvalid: {
      type: Boolean,
      default: false,
    },
    titleForConfirm: {
      type: String,
      default: '',
    },
  },

  computed: { ...mapGetters('breakpoint', ['isXs']) },

  methods: {
    close() {
      this.$emit('close')
    },
    save() {
      this.$emit('save')
    },
  },
}
</script>
